import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { Http, Headers } from "@angular/http";

import { AngularFireAuth } from "@angular/fire/auth";
import { AngularFirestore } from "@angular/fire/firestore";
// import { User } from "../users/users.component";
import { MatTableDataSource, MatSort, MatPaginator, MatDialog } from "@angular/material";
// import { LoggerService } from "src/app/logger.service";
import { map } from "rxjs/operators";
import { LoggerService } from "../../logger.service";
import { HttpHeaders } from "@angular/common/http";
import { ActivatedRoute } from "@angular/router";
import { BsModalRef, BsModalService, ModalOptions } from "ngx-bootstrap/modal";

// import { PDFJSStatic } from 'pdfjs-dist';
// const jsPDF: PDFJSStatic = require('pdfjs-dist');
// jsPDF.getDocument("helloworld.pdf").then(console.log);

// https://bundlephobia.com/result?p=jspdf@1.4.1
declare var jsPDF;

@Component({
  selector: "app-invoices",
  templateUrl: "./invoices.component.html",
  styleUrls: ["./invoices.component.css"]
})
export class InvoicesComponent implements OnInit {
  constructor(
    private modalService: BsModalService,
    public afs: AngularFirestore,
    ls: LoggerService,
    public dialog: MatDialog,
    public http: Http,
    public auth: AngularFireAuth,
    private activatedRoute: ActivatedRoute
  ) {
    this.dataSource = new BillingAgreementDataSource();
    this.dataSource.data = [
      {
        id: "",

        agreement_details: "",
        description: "",
        state: "",
        start_date: ""
        //   resource.state:string;
        // resource.billing_agreement_id :string;
      }
    ];

    // this.dataSource = new InvoiceDataSource();
    // this.dataSource.data = [
    //   {
    //     user: null,
    //     invoicenumber: '<img src="/assets/ajax-loader.gif" />',
    //     datecreated: "",
    //     positions: null,
    //     currency: null,
    //     amount: 0,
    //     duedate: null,
    //     uid: null
    //   }
    // ];

    this.entries = afs.collection("invoices").valueChanges();
    //   this.options = "option";

    this.activatedRoute.queryParams.subscribe(params => {
      console.log("params ", params); // Print the parameter to the console.

      if (params.token) {
        this.pptoken = params.token;
        //     this.executeplan(params.token);
      }
    });
  }
  studies: any;
  bla: string;
  diskusage: number;
  ip: string;
  ipstr: string;
  public entries: any;
  test: string;
  again: boolean;
  public uid: string;
  public chart: any;
  usero: any;
  user: any;
  invoices: any;
  paypallinkstr: string;
  entrieso: any;

  public doc: any;

  @ViewChild(MatPaginator)
  paginator2: MatPaginator;
  @ViewChild(MatSort)
  sort2: MatSort;

  dataSource2: MatTableDataSource<BillingAgreement>;

  @ViewChild(MatPaginator)
  paginator: MatPaginator;
  @ViewChild(MatSort)
  sort: MatSort;

  filter: string;
  filter2: string;

  dataSource: MatTableDataSource<BillingAgreement>;

  displayedColumns2 = ["id", "baid", "create_time", "event_type", "resource", "calltime"];
  displayedColumns = [
    "state",
    "next_billing_date",
    "last_payment_date",
    "start_date",
    "description",
    "functions"
  ];

  public options: any;
  pptoken: string;
  agreements: any;
  ppbillingplans: any;
  webhookscalled: any;

  // tslint:disable-next-line:member-ordering
  ppurl: string;

  modalRef: BsModalRef;

  ngOnInit() {
    //  this.dataSource = new InfotableDataSource(this.afs, this.paginator, this.sort);
    console.log("init invoinces");
   
  }

    // tslint:disable-next-line:use-life-cycle-interface
  ngAfterViewInit() {

    this.afs
      .collection("invoices")
      .snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data();
            const id = a.payload.doc.id;

            return { id, ...data };
          });
        })
      )
      .subscribe(x => {
        this.dataSource.data = <any>x;
        this.dataSource.filter = this.filter;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });

    this.afs
      .collection("ppbillingagreements")
      .snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data();
            const id = a.payload.doc.id;

            return { id, ...data };
          });
        })
      )
      .subscribe(x => {
        if (x) {
          this.agreements = x;
          this.dataSource.data = <any>x;

          this.dataSource.sortingDataAccessor = (item, property) => {
            console.log('sda', property, item);
            switch (property) {
              case "last_payment_date":
                return item.agreement_details.last_payment_date;
              case "next_billing_date":
                return item.agreement_details.next_billing_datee;
              case "start_date":
                return item.agreement_details.start_date;
              default:
                return item[property];
            }
          };

          this.dataSource.filter = this.filter;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      });

    this.afs
      .collection("ppbillingplans")
      .snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data();
            const id = a.payload.doc.id;

            return { id, ...data };
          });
        })
      )
      .subscribe(x => {
        this.ppbillingplans = x;
      });
  }

  getbillingagreementslogs(ba){
    this.afs
      .collection("ppbillingagreements/"+ba.id+"/logs")
      .valueChanges()
      .subscribe(x => {
        if (x) {
          console.log(x);
          ba.logs = x;
        }
      });
  }

  createbillingplan(amount, description, tax, cycles, frequency, frequence_interval) {
    console.log("createbillingplan", amount.value);


    this.http
      .get("https://us-central1-layoutgenerator-c172a.cloudfunctions.net/createbillingplan?amount=" + amount.value + "&description="+description.value+"&tax="+tax.value+"&cycles="+cycles.value+"&frequency="+frequency.value+"&frequency_interval="+frequence_interval.value+ "&currency=USD")
      .subscribe(data => {
        console.log("createbillingplan result ", data);
      });
  }
deleteplan(id){
  this.afs.collection('ppbillingplans').doc(id).delete();
}
  ppbillingagreements(id) {
    this.afs
      .collection("ppbillingagreements")
      .doc(id)
      .delete();
  }
  cancelagreement(billingagreementid) {
    console.log("cancelagreement", billingagreementid);
    this.http
      .get(
        "https://us-central1-layoutgenerator-c172a.cloudfunctions.net/cancelagreement?billingagreementid=" +
          billingagreementid
      )
      .subscribe(data => {
        console.log("cancelagreement result ", data);
      });
  }



  public createSubscription(planid,description,uid) {
    let httpOptions = { headers: new HttpHeaders({ "Content-Type": "application/json" }) }; // , apikey: "384f23e83c581af15cfae7785aa4a67f", password: "7145735e31ceef3d5ada94d004228426" }) };

    console.log("createSubscription()");
    this.http
      .get("https://us-central1-layoutgenerator-c172a.cloudfunctions.net/createsubscription?billingplanid=" + planid + "&description=" + description + "&uid=" + uid )
      .subscribe(data => {
        //   this.http.get("https://us-central1-la<syoutgenerator-c172a.cloudfunctions.net/pay").subscribe(data => {

        var _body = JSON.parse((<any>data)._body);
        //     "{"approval_url":"https://www.sandbox.paypal.com/cgi-bin/webscr?cmd=_express-checkout&token=EC-3J3417293G5688715"}"
        console.log("createSubscription result ", _body);
        this.ppurl = _body.approval_url;
      });
  }

  public getbillingplans() {
    console.log("getbillingplans()");
    this.http.get("https://us-central1-layoutgenerator-c172a.cloudfunctions.net/getbillingplans").subscribe(data => {
      console.log("getbillingplans result ", data);
    });
  }
  public executeplan(token) {
    console.log("executeplan()");
    this.http
      .get("https://us-central1-layoutgenerator-c172a.cloudfunctions.net/executeplan?token=" + token)
      .subscribe(data => {
        var json = JSON.parse((<any>data)._body);
        console.log("executeplan result ", json);
        // "{"billingAgreement":{"id":"I-K2H30W9E4HD7","state":"Pending","description":"Agreement for Fast Speed Plan","start_date":"2019-03-10T08:00:00Z","payer":{"payment_method":"paypal","status":"verified","payer_info":{"email":"daniel.zuidinga@rwth-aachen.de","first_name":"daniel","last_name":"test","payer_id":"A4T6E8WNE6ZML","shipping_address":{"recipient_name":"daniel test","line1":"StayBr111idge Suites","line2":"Cro12ok Street","city":"San Jose","state":"CA","postal_code":"95112","country_code":"US"}}},"shipping_address":{"recipient_name":"daniel test","line1":"StayBr111idge Suites","line2":"Cro12ok Street","city":"San Jose","state":"CA","postal_code":"95112","country_code":"US"},"plan":{"payment_definitions":[{"type":"TRIAL","frequency":"Day","amount":{"value":"20.00"},"cycles":"4","charge_models":[{"type":"TAX","amount":{"value":"20.00"}},{"type":"SHIPPING","amount":{"value":"10.60"}}],"frequency_interval":"1"},{"type":"REGULAR","frequency":"Day","amount":{"value":"100.00"},"cycles":"0","charge_models":[{"type":"TAX","amount":{"value":"20.00"}},{"type":"SHIPPING","amount":{"value":"10.60"}}],"frequency_interval":"1"}],"merchant_preferences":{"setup_fee":{"value":"25.00"},"max_fail_attempts":"1","auto_bill_amount":"YES"},"currency_code":"USD"},"links":[{"href":"https://api.sandbox.paypal.com/v1/payments/billing-agreements/I-K2H30W9E4HD7","rel":"self","method":"GET"}],"agreement_details":{"outstanding_balance":{"value":"0.00"},"cycles_remaining":"4","cycles_completed":"0","final_payment_date":"1970-01-01T00:00:00Z","failed_payment_count":"0"},"httpStatusCode":200}}"
      });
  }

  public getbillingagreement(baid, a) {
    console.log("getbillingagreement(" + baid);
    this.http
      .get(
        "https://us-central1-layoutgenerator-c172a.cloudfunctions.net/getbillingagreement?billingagreementid=" + baid
      )
      .subscribe(data => {
        a = JSON.parse((<any>data)._body);
        console.log("getbillingagreement result ", a);

        // eslint-disable-next-line promise/catch-or-return
        this.afs
          .collection("ppbillingagreements")
          .doc(a.id)
          .update(a)
          .then();
      });
  }

  public onepay() {
    let httpOptions = { headers: new HttpHeaders({ "Content-Type": "application/json" }) }; // , apikey: "384f23e83c581af15cfae7785aa4a67f", password: "7145735e31ceef3d5ada94d004228426" }) };

    console.log("onepay()");

    this.http.get("https://us-central1-layoutgenerator-c172a.cloudfunctions.net/pay").subscribe(data => {
      console.log("onepay result ", data);
    });
  }
  /////////
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }
  applyFilter2(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource2.filter = filterValue;
  }

  deleteLog(id) {
    console.log("delete " + id);
    this.afs.doc("/invoices/" + id).delete();
  }

  openModal(template: TemplateRef<any>) {
    const config: ModalOptions = { class: "modal-big" };

    this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
  }

  public payinvoice(invoice) {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    invoice.hidepaypal = true;
    //       (<any>this.http.post('http://localhost:44300/paypallink', JSON.stringify(invoice), { headers: headers }))

    (<any>(
      this.http.post("https://engineeron.azurewebsites.net/paypallink", JSON.stringify(invoice), { headers: headers })
    )).subscribe(
      event => {
        console.log("paypallink event ", event);
        //    this.paypallink = this.sanitizer.bypassSecurityTrustUrl(event._body.split('"').join(''));
        this.paypallinkstr = event._body.split('"').join("");
        console.log(this.paypallinkstr);
        window.document.location.href = this.paypallinkstr;
        //  window.open(this.paypallinkstr);
      },
      error => {
        //   this.savemessage1 = error;

        console.log("ERROR ", error);
      }
    );

    //  redirect https://simulaton.com/package?paymentId=PAY-02R90160FR819913RK76BMOQ&token=EC-5C916383NM510962Y&PayerID=YPDFULY5GYKDY
  }

  public createInvoice(invoice: Invoice): string {
    invoice = new Invoice();
    invoice.uid = "Fdsf";
    invoice.currency = "EUR";
    invoice.datecreated = new Date().getTime();
    invoice.invoicenumber = "R123";
    invoice.amount = 11.33;
    const np: InvoicePosition = new InvoicePosition();
    np.description = "fdlskjfsa";
    np.nr = 1;
    np.price = 10.99;

    invoice.positions = [];
    invoice.positions.push({ ...np });
    // tslint:disable-next-line:max-line-length
    invoice.user = {
      registerDate: null,
      company: "sfdasdf",
      name: "sfdasdf",
      street: "sfdasdf",
      postcode: "sfdasdf",
      country: "Germany",
      city: "fdafdsaf",
      taxid: "fsdsf",
      email: "fdsfs@asdfsda.de",
      lastLogin: null,
      provider: null,
      uid: "Fdsf",
      vms: null
    };

    //
    console.log("createInvoice " + invoice);

    this.doc = new jsPDF();

    this.doc.setFontSize(36);
    this.doc.setFontType("bold");
    this.doc.text(20, 28, "Invoice");
    this.doc.setFontType("normal");
    const imgData =
      // TODO: auslagern, weil immer mitgeladen!
      // tslint:disable-next-line:max-line-length
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWIAAABPCAYAAADRGc8mAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAHQEAAB0BASrVOW0AABQJSURBVHhe7Z0JtBxFFYb7hQRDVECQgGIEZCfsboCKiqBseSxmQVAOghuouAEuQEhAARE8ioKCIIKAQFifGFCQ1QgEFWQRVBA3VFbFFdfn / 03XhHkvM9N9e2Z6mbnfOX+ qu5NU9XRX3a6uvnVraHR0NCoz0 + dFX3r66ehjDx4fPRUOOY7j9BUTQlpehqI9Ji8X / XDjudFm4YjjOE5fUX5DDKPR2qMTolunz4 / 2D0ccx3H6hmoY4pjJMshnTp8XnbnWfG07juP0CVUyxHX2nxJFt25yZLR22Hccx6k0pTfEEydEE8PmM4xGmw1Niu488LzoI+ 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";

    this.doc.addImage(imgData, "JPEG", 145, 18, 50, 11);
    this.doc.setFontSize(10);
    this.doc.text(-15, 35, "D. Zuidinga", "right");
    this.doc.text(-15, 39, "Passstr. 5", "right");
    this.doc.text(-15, 43, "52070 Aachen", "right");
    this.doc.text(-15, 47, "Germany", "right");

    this.doc.text(-15, 51, "Contact: info@simulaton.com", "right");

    this.doc.setFontSize(10);
    this.doc.text(20, 77, invoice.user.company);
    this.doc.text(20, 81, invoice.user.name);
    this.doc.text(20, 85, invoice.user.street);
    this.doc.text(20, 89, invoice.user.postcode + " " + invoice.user.city);
    this.doc.text(20, 93, invoice.user.country);

    if (invoice.user.taxid) {
      this.doc.text(20, 190, "customer trade tax ID: " + invoice.user.taxid);
    }
    if (invoice.user.country !== "Germany") {
      this.doc.text(20, 200, "reverse charge ");
    }

    this.doc.setFontSize(16);
    this.doc.text(20, 55, "Invoice No. " + invoice.invoicenumber);

    this.doc.setFontSize(10);
    this.doc.text(20, 60, "Date: " + new Date(invoice.datecreated).toISOString().substr(0, 10)); // new Date().toISOString().substr(0, 10));

    this.doc.setFontType("bold");
    this.doc.text(20, 120, "Pos.");
    this.doc.text(35, 120, "Item");
    this.doc.textEx(120, 120, "Amount", "right");
    this.doc.setFontType("normal");
    this.doc.setLineWidth(0.5);
    this.doc.line(20, 124, 190, 124);

    this.doc.text(20, 130, invoice.positions[0].nr + ")");
    this.doc.text(35, 130, invoice.positions[0].description);
    this.doc.textEx(120, 130, invoice.positions[0].price + " " + invoice.currency, "right");

    this.doc.setLineWidth(0.2);
    this.doc.line(140, 145, 190, 145);

    if (invoice.user.country === "Germany") {
      this.doc.text(-55, 150, "VAT 19%:", "right");
      this.doc.textEx(120, 150, invoice.positions[0].price * 0.19 + " " + invoice.currency, "right");
      this.doc.textEx(120, 160, invoice.positions[0].price * 1.19 + " " + invoice.currency, "right");
    } else {
      this.doc.textEx(120, 160, invoice.positions[0].price + " " + invoice.currency, "right");
    }
    this.doc.setFontSize(14);
    this.doc.setFontType("bold");
    this.doc.textEx(100, 160, "SUM:", "right");

    this.doc.setLineWidth(0.2);
    this.doc.line(20, 265, 190, 265);
    this.doc.setFontSize(10);
    this.doc.setFontType("bold");
    this.doc.text(20, 273, "Contact");
    this.doc.setFontType("normal");
    this.doc.text(20, 277, "D. Zuidinga");
    this.doc.text(20, 281, "Passstr. 5");
    this.doc.text(20, 285, "52070 Aachen, Germany");
    this.doc.text(20, 289, "Tax trade ID: DE278971199");

    this.doc.setFontType("bold");
    this.doc.text(70, 273, "Bank");
    this.doc.setFontType("normal");
    this.doc.text(70, 277, "Simulaton.com");
    this.doc.text(70, 281, "Sparkasse Aachen");
    this.doc.text(70, 285, "DE44 3905 0000 1072 2025 81 ");
    this.doc.text(70, 289, "BIC: AACSDE33XXX");

    this.doc.save("invoice-" + invoice.invoicenumber + ".pdf");
    console.log("invoice saved " + "invoice-" + invoice.invoicenumber + ".pdf");

    // in datenbank speichern
    this.afs.collection("/invoices/").add({ ...invoice });

    return "invoice-" + invoice.invoicenumber + ".pdf";
  }

  private getArraySum(array) {
    let i = array.length,
      output = 0;
    while (i) {
      i--;
      output += array[i];
    }
    return output;
  }

  private getCharWidthsArray(text, options) {
    if (!options) {
      options = {};
    }

    const widths = options.widths ? options.widths : this.doc.internal.getFont().metadata.Unicode.widths,
      widthsFractionOf = widths.fof ? widths.fof : 1,
      kerning = options.kerning ? options.kerning : this.doc.internal.getFont().metadata.Unicode.kerning,
      kerningFractionOf = kerning.fof ? kerning.fof : 1;

    // console.log("widths, kergnings", widths, kerning)

    let i,
      l,
      char_code,
      prior_char_code = 0, // for kerning
      // tslint:disable-next-line:prefer-const
      default_char_width = widths[0] || widthsFractionOf,
      // tslint:disable-next-line:prefer-const
      output = [];

    for (i = 0, l = text.length; i < l; i++) {
      char_code = text.charCodeAt(i);
      // tslint:disable-next-line:max-line-length
      output.push(
        (widths[char_code] || default_char_width) / widthsFractionOf +
          ((kerning[char_code] && kerning[char_code][prior_char_code]) || 0) / kerningFractionOf
      );
      prior_char_code = char_code;
    }

    return output;
  }
}
export class PaypalwebhookDataSource extends MatTableDataSource<Paypalwebhook> {
  data: Paypalwebhook[];

  constructor() {
    super();
  }

  disconnect() {}
}
export class BillingAgreementDataSource extends MatTableDataSource<BillingAgreement> {
  data: BillingAgreement[];

  constructor() {
    super();
  }

  disconnect() {}
}
export class Paypalwebhook {
  id: string;
  create_time: any;
  event_type: string;
  resource: any;
  //   resource.state:string;
  // resource.billing_agreement_id :string;
}

export class BillingAgreement {
  id: string;
  agreement_details: any;
  description: string;
  state: string;
  start_date: any;
}

export class InvoiceDataSource extends MatTableDataSource<Invoice> {
  data: Invoice[];

  constructor() {
    super();
  }

  disconnect() {}
}

function compare(a, b, isAsc) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

export class Invoice {
  invoicenumber: string;
  datecreated: any;
  positions: InvoicePosition[];
  amount: number;
  duedate: any;
  currency: string;
  uid: string;
  user: User;
}

export class InvoicePosition {
  nr: number;
  description: string;
  price: number;
}

export class User {
  public name: string;
  public company: string;
  public street: string;
  public postcode: string;
  public city: string;
  public country: string;
  public taxid: string;
  email: string;
  lastLogin: any;
  registerDate: any;
  provider: string;
  uid: string;
  vms: any;
}

// jspdf plugin neu: use: pdf.textEx('Example text', xPosition, yPosition, 'right', 'middle');
const splitRegex = /\r\n|\r|\n/g;
jsPDF.API.textEx = function(x: number, y: number, text: any, hAlign?: string, vAlign?: string) {
  const fontSize = this.internal.getFontSize() / this.internal.scaleFactor;

  // As defined in jsPDF source code
  const lineHeightProportion = 1.15;

  let splittedText: string[];
  // tslint:disable-next-line:no-inferrable-types
  let lineCount: number = 1;
  if (vAlign === "middle" || vAlign === "bottom" || hAlign === "center" || hAlign === "right") {
    splittedText = typeof text === "string" ? text.split(splitRegex) : text;

    lineCount = splittedText.length || 1;
  }

  // Align the top
  y += fontSize * (2 - lineHeightProportion);

  if (vAlign === "middle") {
    y -= (lineCount / 2) * fontSize;
  } else if (vAlign === "bottom") {
    y -= lineCount * fontSize;
  }

  if (hAlign === "center" || hAlign === "right") {
    let alignSize = fontSize;
    if (hAlign === "center") {
      alignSize *= 0.5;
    }

    if (lineCount > 1) {
      for (let iLine = 0; iLine < splittedText.length; iLine++) {
        this.text(splittedText[iLine], x - this.getStringUnitWidth(splittedText[iLine]) * alignSize, y);
        y += fontSize;
      }
      return this;
    }
    x -= this.getStringUnitWidth(text) * alignSize;
  }

  this.text(text, x, y);
  return this;
};
